import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { onAdminAuthStateChanged } from '../../services/adminAuthService';

const RequireAdminAuth = ({ children }) => {
  const [user, setUser] = useState(undefined);
  useEffect(() => {
    const unsubscribe = onAdminAuthStateChanged((u) => setUser(u));
    return unsubscribe;
  }, []);
  if (user === undefined) return null;
  if (!user) return <Navigate to="/admin" replace />;
  return children;
};

export default RequireAdminAuth;